import { render } from "./BalanceSkeleton.vue?vue&type=template&id=00b05ce6&scoped=true"
import script from "./BalanceSkeleton.vue?vue&type=script&lang=js"
export * from "./BalanceSkeleton.vue?vue&type=script&lang=js"

import "./BalanceSkeleton.vue?vue&type=style&index=0&id=00b05ce6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b05ce6"]])

export default __exports__